/*
  ROF Product Gallery — thumbnail switcher
  Definitive fix: strips srcset before setting src,
  uses event capture so it runs before any other handlers.
*/
(function () {
  'use strict';

  function switchToThumb(thumb) {
    var newSrc = thumb.getAttribute('data-large');

    // Fallback to the thumb image src if data-large missing
    if (!newSrc) {
      var ti = thumb.querySelector('img');
      if (ti) newSrc = ti.getAttribute('src');
    }
    if (!newSrc) return;

    // Find the main image — by ID first (most reliable), then by selector
    var mainImg = document.getElementById('OftMainImage') ||
                  document.querySelector('.oft-featured-media img');
    if (!mainImg) return;

    // THE FIX: browser ignores src when srcset is present
    // Must remove srcset and sizes BEFORE setting src
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = newSrc;

    // Update active state
    var allThumbs = document.querySelectorAll('.oft-thumb');
    allThumbs.forEach(function (t) {
      t.classList.toggle('active', t === thumb);
    });
  }

  function handleClick(e) {
    // Walk up from the clicked target to find an .oft-thumb button
    var el = e.target;
    while (el && el !== document) {
      if (el.classList && el.classList.contains('oft-thumb')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        switchToThumb(el);
        return;
      }
      el = el.parentElement;
    }
  }

  // Remove any previously attached listener to avoid duplicates
  document.removeEventListener('click', window._rofGalleryHandler, true);
  window._rofGalleryHandler = handleClick;

  // Use CAPTURE phase so this runs before bubbled handlers
  document.addEventListener('click', handleClick, true);

  // Also handle keyboard (Enter/Space)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = document.activeElement;
    if (el && el.classList && el.classList.contains('oft-thumb')) {
      e.preventDefault();
      switchToThumb(el);
    }
  });

})();
